import React, { type ChangeEvent } from "react"
import { useTranslation } from "react-i18next"
import { TaskFilterTab } from "@/components/filter-tab/task-filter-tab/task-filter-tab.tsx"
import NoResultsFound from "@/components/not-found/no-results-found.tsx"
import PageContentWrapperSmall from "@/components/page-content-wrappers/page-content-wrapper-small.tsx"
import SearchBarGeneral from "@/components/search-bar/search-bar-general.tsx"
import DesktopTopBar from "@/components/top-bars/desktop-top-bar.tsx"
import MobileTopBar from "@/components/top-bars/mobile-top-bar/mobile-top-bar.tsx"
import CountNumber from "@/features/farm/components/count-number/count-number.tsx"
import { taskClassificationCheckNotAllEmpty } from "@/features/tasks"
import TaskTable from "@/features/tasks/components/table/task-table.tsx"
import { TasksListCurrent } from "@/features/tasks/components/tasks-lists/tasks-list-current.tsx"
import { TasksListDone } from "@/features/tasks/components/tasks-lists/tasks-list-done.tsx"
import useFilteredTasks from "@/features/tasks/hooks/use-filter-tasks.ts"
import { NEW_TASK_VIEW } from "@/features/tasks/routes/route-list.ts"
import { useMediaQuery } from "@/hooks/use-media-query.ts"

const TasksTab: React.FC = () => {
  const { t } = useTranslation()
  const isDesktop = useMediaQuery("(min-width: 768px)")
  const {
    searchQuery,
    setSearchQuery,
    filteredTasks,
    selections,
    setSelections,
  } = useFilteredTasks()

  const handleSearchInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value)
  }

  const hasTasks = taskClassificationCheckNotAllEmpty(filteredTasks)

  const flattenedTasks = selections.is_done
    ? filteredTasks.doneTasks
    : [
        ...filteredTasks.dueTasks,
        ...filteredTasks.currentTasks,
        ...filteredTasks.futureTasks,
      ]

  return (
    <>
      <MobileTopBar navigateTo={NEW_TASK_VIEW} title={t("tasks")} />
      <PageContentWrapperSmall>
        <DesktopTopBar navigateTo={NEW_TASK_VIEW} title={t("tasks")} />
        <SearchBarGeneral
          value={searchQuery}
          onChange={handleSearchInputChange}
          placeholder={t("searchTask")}
        />
        <TaskFilterTab onFilterChange={setSelections} />
        <CountNumber count={flattenedTasks.length} text={t("tasks")} />

        {!hasTasks && <NoResultsFound message={t("noTasksFound")} />}
        {hasTasks &&
          (isDesktop ? (
            <TaskTable tasks={flattenedTasks} />
          ) : selections.is_done ? (
            <TasksListDone filteredTasks={filteredTasks} />
          ) : (
            <TasksListCurrent filteredTasks={filteredTasks} />
          ))}
      </PageContentWrapperSmall>
    </>
  )
}

export default TasksTab
